export default {
    getWorkVideo (state) {
        return state.workVideo
    },
    getLifeVideos (state) {
        return state.lifeVideo
    },
    getMindbodyVideo (state) {
        return state.mindbodyVideo
    },
    getCommunityVideo (state) {
        return state.communityVideo
    },
    getMoneyVideo (state) {
        return state.moneyVideo
    },
    getMainVideo (state) {
        return state.mainVideo
    },
    getAboutUsVideo (state) {
        return state.aboutusVideo
    },
    getWorkLearnMoreVideo (state) {
        return state.workLearnMore
    },
    getLifeLearnMoreVideo (state) {
        return state.lifeLearnMore
    },
    getMoneyLearnMoreVideo (state) {
        return state.moneyLearnMore
    },
    getMindbodyLearnMoreVideo (state) {
        return state.mindbodyLearnMore
    },
    getCommunityLearnMoreVideo (state) {
        return state.communityLearnMore
    },
    getAllUnauthVideos (state) {
        return state.allUnauthVideos
    },
    getCorpReference (state) {
        return state.corpReference
    },
    getLiveEventVideo (state) {
        return state.liveEventVideo
    },
    getAllTestimonials (state) {
        return state.allTestimonials
    },
    getMarketingPlan (state) {
        if (sessionStorage.getItem('marketingPlan')) {
            state.marketingPlanId = sessionStorage.getItem('marketingPlan')
            return state.marketingPlanId
        } else {
            return null
        }
    },
    getCorporateGiftingCode (state) {
        if (state.corporateGiftingCode) {
            return state.corporateGiftingCode
        } else {
            if (localStorage.getItem('corporateGiftingCode')) {
                state.corporateGiftingCode = localStorage.getItem('corporateGiftingCode')
                return state.corporateGiftingCode
            } else {
                return null
            }
        }
    },
    getCorporateClientId (state) {
        if (state.corporateClientId) {
            return state.corporateClientId
        } else {
            if (localStorage.getItem('corporateClientId')) {
                state.corporateClientId = localStorage.getItem('corporateClientId')
                return state.corporateClientId
            } else {
                return null
            }
        }
    },
    getLoginTriggerStatus (state) {
        return state.triggerLogin
    },
    getCompanyLogos (state) {
        return state.companyLogos
    }
}



// WEBPACK FOOTER //
// ./src/store/unauthpage/getters.js